export default "__VITE_PUBLIC_ASSET__d5c60ef6__"